import { Injectable } from '@angular/core';

@Injectable()
export class IncidentConstantsService {
  constructor() { }
  // URL constant
  public static IncidentURL = {
    GetIncidentTypeByCompanyId: 'api/incident/configuration/getIncidentTypeDetails',
    GetIncidentCategoryByCompanyId: 'api/incident/configuration/getIncidentCategoryDetails',
    RaiseIncident: 'api/incident/raise/incidentRequest',
    GetIncidentRequestByUserId: 'api/incident/get/incidentRequestByUserId',
    GetIncidentDataByIncidentId: 'api/incident/get/incidentByIncidentRequestId',
    UpdateIncidentData: 'api/incident/update/incidentRequest',
    GetIncidentRequestByIncidentRequestId: 'api/incident/get/incidentRequestByIncidentRequestId',
    CloseRequestByIncidentRequestId: 'api/incident/close/incidentByIncidentRequestId',
    Saveorupdateincidentrating: 'api/incident/close/saveorupdateincidentrating',
    DownloadPDF: 'api/incident/get/downloadpdf',
    SavePDF: 'api/incident/savepdf',
    SaveActions: 'api/incident/saveActions',
    SaveCaseOwnerAction: 'api/incident/saveCaseOwnerAction',
    GetActionByIncidentId: 'api/incident/getActionByIncidentId',
    GetCaseOwnerSubmittedDetails: 'api/incident/getCaseOwnerSubmittedDetails',
    GetExportToExcelIncidentRequestByUserId: 'api/incident/get/exporttoexcelincidentRequestByUserId',
    GetIncidentProcessDetails: 'api/incident/get/getIncidentProcessDetails',
    GetInvestigationDetails: 'api/incident/get/getInvestigationDetails',
    DownloadZIP: 'api/incident/get/downloadzip',
    GetIncidentRatings: 'api/incident/getincidentratings'
  };
  // ROUTE NAME
  public static RouteName = {
    CaseOwnerdashboard: 'Case Owner dashboard',
    ReportIncident: 'Report Incident'
  };


  public static Consequence = [
    {
      Name: 'No Values',
      Value: 0,
    }, {
      Name: 'A- Rare',
      Value: 'A',
    },
    {
      Name: 'B- Unlikely',
      Value: 'B',
    },
    {
      Name: 'C- Moderate',
      Value: 'C',
    },
    {
      Name: 'D- Likely',
      Value: 'D',
    },
    {
      Name: 'E- Probable',
      Value: 'E',
    }];
  public static PeopleSeverity = [
    {
      Name: 'No Health effect/Injury',
      Value: 0
    }, {
      Name: '1- FAC',
      Value: 1
    },
    {
      Name: '2- MTC',
      Value: 2
    },
    {
      Name: '3- LTI',
      Value: 3
    },
    {
      Name: '4- PTD or 1 fatality',
      Value: 4
    },
    {
      Name: '5- Multiple fatalities',
      Value: 5
    },
  ];
  public static EnvironmentSeverity = [
    {
      Name: 'No effect',
      Value: 0
    }, {
      Name: '1- Slight effect',
      Value: 1
    },
    {
      Name: '2- Minor effect',
      Value: 2
    },
    {
      Name: '3- Moderate effect',
      Value: 3
    },
    {
      Name: '4- Major effect',
      Value: 4
    },
    {
      Name: '5- Massive effect',
      Value: 5
    },
  ];
  public static AssetsSeverity = [
    {
      Name: 'No damage',
      Value: 0
    }, {
      Name: '1- Slight damage < US $50K',
      Value: 1
    },
    {
      Name: '2- Minor damage < US $500K',
      Value: 2
    },
    {
      Name: '3- Localised damage < US $2M',
      Value: 3
    },
    {
      Name: '4- Major damage < US $20M',
      Value: 4
    },
    {
      Name: '5- Extensive damage < US $20M',
      Value: 5
    },
  ];
  public static ReputationSeverity = [
    {
      Name: 'No concern',
      Value: 0
    }, {
      Name: '1- No concerns',
      Value: 1
    },
    {
      Name: '2- Individual concerns',
      Value: 2
    },
    {
      Name: '3- Local community attention',
      Value: 3
    },
    {
      Name: '4- National attention',
      Value: 4
    },
    {
      Name: '5- International attention',
      Value: 5
    },
  ];
  public static NPTSeverity = [
    {
      Name: '< 2',
      Value: 0
    }, {
      Name: '1- > 2 & < 6',
      Value: 1
    },
    {
      Name: '2- > 6 & < 12',
      Value: 2
    },
    {
      Name: '3- > 12 & < 24',
      Value: 3
    },
    {
      Name: '4- > 24 & < 48',
      Value: 4
    },
    {
      Name: '5- > 48',
      Value: 5
    },
  ];
  public static IncidentType = {
    Potential: 'Potential',
    Residual: 'Residual',
    Assessment: 'Assessment'
  };


  // Module specific constants
  public static CommunicationSource = {
    CommunicationSource: [
      {
        Id: 1,
        Value: 'Email',
      },
      {
        Id: 2,
        Value: 'Phone',
      },
      {
        Id: 3,
        Value: 'Fax'
      }
    ]
  };

  public static Job = {
    Job: [
      {
        Id: 1,
        Value: 'aa',
      },
      {
        Id: 2,
        Value: 'ac',
      },
      {
        Id: 3,
        Value: 'ab'
      }
    ]
  };

  public static IncidentAction = {
    CaseOwnerAction: [
      { Name: 'Submit TOR', FileUrl: [], dueDate: new Date(), Enabled: true, SelectedMarkAction: false },
      { Name: 'Submit Draft Report', FileUrl: [], dueDate: new Date(), Enabled: true, SelectedMarkAction: false },
      { Name: 'Submit Final Investigation Report', FileUrl: [], dueDate: new Date(), Enabled: true, SelectedMarkAction: false }
    ]
  };
                                                                                     
  // Company Name
  public static CompanyConst = {
    B44: 'B44',
    QAMP: 'QAMP',
    INC: 'INC'
  }

  // Incident Status
  public static IncidentStatus = {
    New: 'New',
    Closed: 'Closed',
    Cancelled: 'Cancelled',
    Deleted: 'Deleted',
    Draft: 'Draft'
  };

  // Dashboard Filter
  public static DasboardFilter = {
    SubmitDate: 'Submit Date',
    DESC: 'DESC',
    ASC: 'ASC',
    IncidentId: 'IncidentId',
    CaseOwnerId: 'CaseOwnerId',
    LocationId: 'LocationId'
  };

  public static RoutingURLConstant = {
    RaiseIncidentURL: '/incident/report-incident/0',
    IncidentDashBoardURL: '/incident/incident-overview',
    CaseOwnerDashboardURL: '/incident/incident-case-owner-dashboard'
  };
  // Side bar routesURL and routeName of Incident
  public static IncidentNavigation = {
    Routes: [
      {
        routeName: 'Home',
        routeURL: '../../home',
        isClickable: true
      },
      {
        routeName: 'Report Incident',
        routeURL: '/incident/report-incident/new',
        isClickable: true
      },
      {
        routeName: 'Incident Overview',
        routeURL: '/incident/incident-overview',
        isClickable: true
      },
      // {
      //   routeName: 'Case Owner dashboard',
      //   routeURL: '/incident/incident-case-owner-dashboard'
      // }
    ],
    InnerRoutes: [
      {
        routeName: 'Home',
        routeURL: '../../../home',
        isClickable: true
      },
      {
        routeName: 'Report Incident',
        routeURL: '/incident/report-incident/new',
        isClickable: true
      },
      {
        routeName: 'Incident Overview',
        routeURL: '/incident/incident-overview',
        isClickable: true
      },
      // {
      //   routeName: 'Case Owner dashboard',
      //   routeURL: '/incident/incident-case-owner-dashboard'
      // }
    ],

    ReportRoutes: [
    ]
  };

  //Incident Roles
  public static ActionType = {
    Actions: [
      {
        Id: 1,
        Value: 'MyIncidents',
        Description: 'MyIncidents',
        checked: true
      },

      {
        Id: 2,
        Value: 'CaseOwner',
        Description: 'CaseOwner',
        checked: false
      },
      {
        Id: 3,
        Value: 'All',
        Description: 'All',
        checked: false
      }
      // {
      //   Id:4,
      //   Value: 'BackOffice',
      //   Description:'BackOffice',
      //   checked : false
      // }
    ]
  }


  // Event on Click
  public static EventType = {
    mouseenter: 'mouseenter',
  };
  public static RiskType = {
    Incident: 'Incident'
  };
}
